import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertsService } from '@tablesready/frontend-alerts-bar';
import { IAlertTypes } from '@tablesready/frontend-alerts-bar';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private readonly alertsService: AlertsService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0) {
          this.alertsService.add({
            id: 'network-connection-lost',
            duration: 7 * 24 * 60 * 60 * 1000, // 7 days
            time: Date.now(),
            type: IAlertTypes.danger,
            heading: 'Oops.',
            body: 'It looks like there\'s a problem with your connection',
            actions: [
              {
                label: 'Click here to reload',
                action: (): void => {
                  window.location.reload();
                },
              },
            ],
          });
        }
        return throwError(() => error);
      }));
  }
}
